// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_hYn","tabsBox":"styles_tabsBox__2SNDL","createButton":"styles_createButton__YyfeC"};